<mat-card>
    <mat-card-title> Excluir Produto</mat-card-title>
    <form>
      <mat-form-field>
        <input
          matInput
          placeholder="Nome"
          [value]="product.name"
          name="name" disabled
        />
      </mat-form-field>
      <mat-form-field>
        <input
          matInput
          placeholder="Preço R$"
          [value]="product.price"
          name="price" disabled
        />
      </mat-form-field>
    </form>
    <button mat-raised-button (click)="deleteProduct()" class="btn-delete">
      Excluir
    </button>
    <button mat-raised-button (click)="cancel()">Cancelar</button>
  </mat-card>
  
